import {useEffect, useState} from "react";

interface MyCredentialRequestOptions extends CredentialRequestOptions {
    otp: { transport: string[] };
}

interface OTPCredential extends Credential {
    code: string;
}

export const useConfirmation = ({checkCodeCb, checkCodeSms, values}) => {
    const [isCodeTimeout, setIsCodeTimeout] = useState(0);

    /**Код для автоматической подстановки кода из sms */
    if ('OTPCredential' in window) {
        window.addEventListener('DOMContentLoaded', () => {
            const input: HTMLInputElement = document.querySelector('input[autoComplete="one-time-code"]');

            if (!input) return;

            const ac = new AbortController();

            if (checkCodeSms) {
                ac.abort();
            }

            const options: MyCredentialRequestOptions = {
                otp: { transport: ['sms'] },
                signal: ac.signal,
            };

            navigator.credentials
                .get(options)
                .then((otp: OTPCredential) => {
                    input.value = otp.code;
                })
                .catch((err) => {
                    console.error(err);
                });
        });
    }

    useEffect(() => {
        let timeoutId: NodeJS.Timeout;

        if (isCodeTimeout > 0) timeoutId = setTimeout(() => setIsCodeTimeout(isCodeTimeout - 1), 1000);

        return () => {
            timeoutId && clearTimeout(timeoutId);
        };
    }, [isCodeTimeout]);

    useEffect(() => {
        if (values.code.length >= 5) checkCodeCb();
    }, [values.code]);

    return {
        isCodeTimeout, setIsCodeTimeout
    }
}